import { forwardRef } from 'react';
import { BaseCalendar } from './__internal__/BaseCalendar';
import { jsx as _jsx } from "react/jsx-runtime";
export const Calendar = /*#__PURE__*/forwardRef(function Calendar({
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(BaseCalendar, {
    ...props,
    ref: ref
  });
});
//# sourceMappingURL=Calendar.js.map